/**
 * @module utils.timePattern
 *
 * CFTB-3431: the clock a booking screen writes times in, as a Luxon format token.
 *
 * The screens had `h:mm a` hard-coded, so a coach who set 24-hour times still saw
 * "2:15 PM" on their public calendar. The preference reaches them through
 * `useCalendarPreferences`, which resolves whose setting applies — the reader's own
 * when signed in, the coach's on their public calendar.
 */
import { CalendarPreferences } from "app/models/CalendarPreferences";

/** "14:15" for a coach on 24-hour, "2:15 PM" otherwise. */
export const timePattern = (
  timeFormat?: CalendarPreferences["timeFormat"],
): string => (timeFormat === "24h" ? "HH:mm" : "h:mm a");
